import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    isScrolled = false;
    isDropdownOpen: any = false;
    isMenuOpen = false;
    activeSchoolIndex = 0;
    departmentDropdownOpen = false;
    subMenus: { [key: string]: boolean } = {};
    submenuOpen: { [key: number]: boolean } = {};
    private dropdownTimeout: any;
    title = 'ARNI University';
    dropDown: any = {};

    MenuDetail = [
        {
            name: 'ARNI School of Technology',
            schoolDetail: [
                {
                    name: 'About Us',
                    link: '/ast',
                },
                {
                    name: 'Syllabus',
                    link: '/ast-syllabus',
                },
                {
                    name: 'Department',
                    submenu: [
                        {
                            name: 'Civil Engineering',
                            link: '/ast-civil-engineering',
                        },
                        {
                            name: 'Mechanical Engineering',
                            link: '/ast-mechanical-engineering',
                        },
                        {
                            name: 'Computer Science Engineering',
                            link: '/ast-computer-science-engineering',
                        },
                        {
                            name: 'Computer Science & Application',
                            link: '/ast-computer-science-application',
                        },
                        {
                            name: 'ECE & EE',
                            link: '/ast-ece-ee',
                        },
                        {
                            name: 'Cyber Security and AI',
                            link: '/ast-cyber-security',
                        },
                    ],
                },
                {
                    name: 'Contact Us',
                    link: 'ast-contactus',
                },
            ],
            schoolContent: [
                {
                    image: 'assets/img/ArniSchool01/14.jpg',
                    content:
                        'Welcome to The ARNI School of Technologies (AST), the place where ideas turn into reality. The students seeking careers in a variety of technological sectors can learn postgraduate and undergraduate courses in Arni University. We have a long-term vision to craft a transformative learning environment where students are not just taught technical skills but are provided with relevant exposure that helps them to lead and drive growth in the technological landscape. We are on a mission to spread knowledge and skills that empower students in this dynamic field of technology and innovations. We aim to provide them with a platform that encourages interdisciplinary collaboration, hands-on learning, and research-driven exploration.',
                },
            ],
        },
        {
            name: 'Arni School of Business Management & Commerce',
            schoolDetail: [
                {
                    name: 'About Us',
                    link: '/asbmc',
                },
                {
                    name: 'Syllabus',
                    link: '/asbmc-syllabus',
                },
                {
                    name: 'Department',
                    submenu: [
                        {
                            name: 'Business Studies',
                            link: '/asbmc-business-studies',
                        },
                        {
                            name: 'Commerce',
                            link: '/asbmc-commerce',
                        },
                        {
                            name: 'Hospitality Management',
                            link: '/asbmc-hospitality-management',
                        },
                    ],
                },
                {
                    name: 'Contact Us',
                    link: 'asbmc-contactus',
                },
            ],
            schoolContent: [
                {
                    image: 'assets/img/ArniSchool02/4%20(1).jpg',
                    content:
                        'The ARNI School of Business Management & Commerce is the place where potential leaders transform into business professionals. Students looking to pursue their career in the field of business and finance management opt for The School of Business Management & Commerce degree courses from ARNI University division. Our approach to encouraging future leaders, entrepreneurs, and professionals is not only to shape the business world but to also contribute to economic, social, and environmental progress. Our programs are designed to equip students with the necessary skills and knowledge in this fast-paced business world.',
                },
            ],
        },
        // Add additional schools and details here as needed
        {
            name: 'Programmes',
            link: '/programmes',
        },
        {
            name: 'Placement',
            link: '/placement',
        },
        {
            name: 'Alumni',
            link: '/student-info-detail',
        },
        {
            name: 'Infrastructure',
            link: '/infrastructure',
        },
    ];

    constructor(private router: Router) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.isDropdownOpen = false;
            }
        });
    }

    ngOnInit() {
        // Check initial scroll position
        this.onWindowScroll();

        // Force fixed header on initialization
        this.forceFixedHeader();

        // Add a resize event listener to ensure header remains fixed
        window.addEventListener('resize', this.forceFixedHeader.bind(this));
    }

    // Force the header to be fixed regardless of CSS conflicts
    forceFixedHeader() {
        setTimeout(() => {
            const headerElement = document.querySelector(
                'header'
            ) as HTMLElement;
            if (headerElement) {
                headerElement.style.position = 'fixed';
                headerElement.style.top = '0';
                headerElement.style.left = '0';
                headerElement.style.right = '0';
                headerElement.style.width = '100%';
                headerElement.style.zIndex = '1000';
            }
        }, 100);
    }

    openSubMenuDropDown(dropdown: string) {
        this.dropDown[dropdown] = !this.dropDown[dropdown];
    }

    setActiveSchool(index: number) {
        this.activeSchoolIndex = index;
        this.departmentDropdownOpen = false;
    }

    toggleSubMenu(menu: string) {
        this.subMenus[menu] = !this.subMenus[menu];
    }

    toggleDepartmentDropdown() {
        this.departmentDropdownOpen = !this.departmentDropdownOpen;
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        this.subMenus = {};
        this.dropDown = {};
    }

    openDropdown() {
        clearTimeout(this.dropdownTimeout);
        this.isDropdownOpen = true;
    }

    closeDropdownn() {
        this.dropdownTimeout = setTimeout(() => {
            this.isDropdownOpen = false;
        }, 200);
    }

    keepDropdownOpen() {
        clearTimeout(this.dropdownTimeout);
    }

    @HostListener('document:click', ['$event'])
    closeDropdown(event: Event) {
        const target = event.target as HTMLElement;
        if (!target.closest('.group')) {
            this.isDropdownOpen = null;
        }
    }

    navigateTo(route: string) {
        this.isDropdownOpen = null;
        this.router.navigate([route]);
    }

    goTo(url: string) {
        this.isMenuOpen = false;
        this.router.navigateByUrl(url);
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {
        const scrollPosition = window.scrollY;

        // Use requestAnimationFrame for smoother transitions
        requestAnimationFrame(() => {
            // Set isScrolled based on scroll position
            this.isScrolled = scrollPosition > 50;

            // Force header to remain at top on each scroll
            this.forceFixedHeader();
        });
    }
}
